import { Observable } from 'rxjs';
import { HttpOptions } from '../http-client';
import { CommonDataModel, ResponseFromServer } from '../../_models';

export interface IServerHttpClient {
  /**
   * Makes a GET request and returns unwrapped data.
   * This is the PREFERRED method for new code.
   * @returns Observable<TResponse> - just the data, without ResponseFromServer wrapper
   */
  get<TResponse>(relativePath: string, options?: HttpOptions): Observable<TResponse>;

  /**
   * Makes a POST request and returns unwrapped data.
   * This is the PREFERRED method for new code.
   * @returns Observable<TResponse> - just the data, without ResponseFromServer wrapper
   */
  post<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse>;

  /**
   * Makes a PUT request and returns unwrapped data.
   * This is the PREFERRED method for new code.
   * @returns Observable<TResponse> - just the data, without ResponseFromServer wrapper
   */
  put<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse>;

  /**
   * Makes a DELETE request and returns unwrapped data.
   * This is the PREFERRED method for new code.
   * @returns Observable<TResponse> - just the data, without ResponseFromServer wrapper
   */
  delete<TResponse>(relativePath: string, options?: HttpOptions): Observable<TResponse>;

  /**
   * Makes a PATCH request and returns unwrapped data.
   * This is the PREFERRED method for new code.
   * @returns Observable<TResponse> - just the data, without ResponseFromServer wrapper
   */
  patch<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse>;

  /**
   * Makes a GET request and returns the full ResponseFromServer.
   * @deprecated Use get() instead. This method exists only for backward compatibility
   * during migration from manual .data unwrapping. New code should use get().
   * @returns Observable<ResponseFromServer<TResponse>> - full server response with metadata
   */
  getRaw<TResponse>(relativePath: string, options?: HttpOptions): Observable<ResponseFromServer<TResponse>>;

  /**
   * Makes a POST request and returns the full ResponseFromServer.
   * @deprecated Use post() instead. This method exists only for backward compatibility
   * during migration from manual .data unwrapping. New code should use post().
   * @returns Observable<ResponseFromServer<TResponse>> - full server response with metadata
   */
  postRaw<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>>;

  /**
   * Makes a PUT request and returns the full ResponseFromServer.
   * @deprecated Use put() instead. This method exists only for backward compatibility
   * during migration from manual .data unwrapping. New code should use put().
   * @returns Observable<ResponseFromServer<TResponse>> - full server response with metadata
   */
  putRaw<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>>;

  /**
   * Makes a DELETE request and returns the full ResponseFromServer.
   * @deprecated Use delete() instead. This method exists only for backward compatibility
   * during migration from manual .data unwrapping. New code should use delete().
   * @returns Observable<ResponseFromServer<TResponse>> - full server response with metadata
   */
  deleteRaw<TResponse>(relativePath: string, options?: HttpOptions): Observable<ResponseFromServer<TResponse>>;

  /**
   * Makes a PATCH request and returns the full ResponseFromServer.
   * @deprecated Use patch() instead. This method exists only for backward compatibility
   * during migration from manual .data unwrapping. New code should use patch().
   * @returns Observable<ResponseFromServer<TResponse>> - full server response with metadata
   */
  patchRaw<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>>;

  /**
   * Makes a GET request and returns data wrapped in CommonDataModel.
   * @deprecated CommonDataModel is an anti-pattern. Use get() instead.
   * This method exists only for backward compatibility during migration.
   * New code should use get() and handle loading/error states at the component level.
   * @returns Observable<CommonDataModel<TResponse>> - data with loading/status metadata
   */
  getExpanded<TResponse>(relativePath: string, options?: HttpOptions): Observable<CommonDataModel<TResponse>>;

  /**
   * Makes a POST request and returns data wrapped in CommonDataModel.
   * @deprecated CommonDataModel is an anti-pattern. Use post() instead.
   * This method exists only for backward compatibility during migration.
   * New code should use post() and handle loading/error states at the component level.
   * @returns Observable<CommonDataModel<TResponse>> - data with loading/status metadata
   */
  postExpanded<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<CommonDataModel<TResponse>>;
}
